export default __webpack_public_path__ + "static/media/ordenadores.96319765.jpg";